import { Form, Input, message, AutoComplete } from "antd";
import React, { useState, useMemo, useContext } from "react";
import { sendCode } from "@api/login";
import "./login_interceptor.less";
import SliderModal from "./react-slider-vertify/slider";
import Captcha from '@pages/aliyun_captcha/App';
import uuid from 'react-uuid'
import { useTranslation } from "react-i18next";
import { debounce } from "lodash";
import loginContext from "@components/login_context";
import { isPrefix, judge } from "@util/utils";
import H5LoginOptions from "./h5_login_options";
import H5FormError from "./h5_form_error";
import FormFieldError from "@components/form_field_error";

export default function ForgetPWDModal({
  setForgetPWDVisible,
  setNewPWDVisible,
  setNewUcode,
  setVisible,
  onWechatLogin,
}) {
  const [forgetForm] = Form.useForm();
  const [fieldErrors, setFieldErrors] = useState({});
  const [unicode, setUcode] = useState("");
  const [tipName, setTipName] = useState("发送验证码");
  const [disabled, setDisabled] = useState(false);
  const [interval, set_interval] = useState(null);
  const [slider, setSlider] = useState(false);
  const [sliderVisible, setSliderVisible] = useState(false);
  const [sendNum, setSendNum] = useState(0);
  const [time, setTime] = useState(0);
  const [options, setOptions] = useState([]);
  const { t } = useTranslation()
  const { handleSearch, isPhone } = useContext(loginContext);
  const prefix = isPrefix();
  const isWx = judge();
  // Only unprefixed H5 inside WeChat uses the new login options layout.
  const isPrefixedH5 = (isPhone && Boolean(prefix)) || !isPhone;
  const showH5LoginOptions = isPhone && !prefix && isWx;
  const showLegacyLoginOptions = isPrefixedH5 || (isPhone && !isWx);
  const reg = /^1[3-9][0-9]\d{8}$/;
  const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const prefixReg = /^\+86[- ]*/;
  const updateFieldErrors = (fields = []) => {
    const errors = {};
    fields.forEach((field) => {
      const fieldName = Array.isArray(field.name)
        ? field.name.join(".")
        : field.name;
      if (fieldName) {
        errors[fieldName] = field.errors || [];
      }
    });
    setFieldErrors(errors);
  };
  const handleFinishFailed = ({ errorFields = [] } = {}) => {
    updateFieldErrors(errorFields);
  };
  const renderFieldError = (fieldName) => {
    const error = fieldErrors[fieldName]?.[0];
    // PC 端与 H5 端展示同样的异常提醒，PC 样式参考 pc-login-modal 的字段报错。
    if (!isPhone) return <FormFieldError error={error} />;
    return <H5FormError error={error} />;
  };
  const sendSmsCode = (res) => {
    const phone = forgetForm.getFieldValue("phone");
    if (!phone || disabled) {
      return;
    }
    if (!sendNum) {
      setTime(new Date().getTime());
    }
    setSendNum(sendNum + 1);
    let nowTime = new Date().getTime();
    if (sendNum > 4 && (nowTime - time) / 1000 < 600) {
      setSliderVisible(true);
      setSlider(true);
    }
    let num = 60;
    setDisabled(true);
    const timer = setInterval(() => {
      if (num >= 1) {
        num -= 1;
        setTipName(num);
      }
      if (num <= 0) {
        setTipName("发送验证码");
        setDisabled(false);
        clearInterval(interval);
      }
    }, 1000)
    set_interval(timer);

    sendCode({
      phone,
      phoneCodeId: res.phoneCodeId
    }).then((res) => {
      if(res.success){
        setDisabled(true);
        // clearInterval(timer);
        setUcode(res.result.unicode);
      }else{
        setTipName("发送验证码");
        setDisabled(false);
        clearInterval(timer);
        message.error(t(res.errorInfo || "获取验证码失败,请重新获取"))
      }
     
    });
  };
  const forgetLoginFn = (e) => {
    if (slider) {
      message.warn(t("请先完成拼图"));
      return;
    }
    e.stopPropagation();
    forgetForm.submit();
  };

  const forgetLogin = debounce(forgetLoginFn, 300)
  const switchToVerificationLogin = (e) => {
    e.stopPropagation();
    setForgetPWDVisible(false);
    setNewPWDVisible(false);
    setDisabled(false);
    setTipName("发送验证码");
    clearInterval(interval);
    setFieldErrors({});
    setVisible(true);
  };

  const phone = Form.useWatch('phone',forgetForm)
  const captchaOpen = useMemo(()=>{
    return  phone && (reg.test(phone) || emailReg.test(phone)) && !disabled
  },[phone,disabled])
  const buttonKey = useMemo(()=>{
    return 'captcha-button-'+uuid()
  },[])

  return (
    <div className={isPhone ? "boxMask phoneLoginMask" : "boxMask"}>
      <div
        className={`${isPhone ? "boxContent phoneLoginContent" : "boxContent"}${
          showH5LoginOptions ? " h5-login-options-fixed" : ""
        }`}
      >
        <div className="text_title">
          <span>{t("找回密码")}</span>
          {/* <div className="image-wrapper_4" onClick={(e) => {
            e.stopPropagation();
            setDisabled(false);
            setTipName("发送验证码");
            setForgetPWDVisible(false);
            // setVisible(true);
            clearInterval(interval);
          }}>
            <img
              className="thumbnail_2"
              referrerPolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/pshr6c9dhlxm56xubgb1swhjj7c6idxbd7iac80a6e6-3d59-4dbf-a6fa-c87ab8e8531e"
            />
          </div> */}
        </div>
        <Form
          labelCol={{ span: 2 }}
          wrapperCol={{ span: 20 }}
          form={forgetForm}
          onFinish={(data) => {
            setNewUcode({
              unicode: unicode,
              phone: data.phone,
              code: data.code,
            });
            setForgetPWDVisible(false);
            setNewPWDVisible(true);
            setDisabled(false);
            setTipName("发送验证码");
            clearInterval(interval);
          }}
          validateTrigger="onBlur"
          onFieldsChange={(_changedFields, allFields) =>
            updateFieldErrors(allFields)
          }
          onFinishFailed={handleFinishFailed}
        >
          <Form.Item
            name="phone"
            wrapperCol={{ offset: 2, span: 20 }}
            help={renderFieldError("phone")}
            getValueFromEvent={(value) => {
              if (prefixReg.test(value)) {
                return value.replace(prefixReg, '');
              }
              return value;
            }}
            rules={[
              {
                required: true,
                message: t("请输入正确的手机号或邮箱账号!"),
              },
              () => ({
                validator(_, value) {
                  let new_value = value;
                  if (prefixReg.test(value)) {
                    new_value = value.replace(prefixReg, '')
                  }
                  if (reg.test(new_value) || emailReg.test(new_value)) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(t("请输入正确的手机号或邮箱账号!")));
                },
              }),
            ]}
          >
            {/* <Input placeholder={i18n?.language=='en'?"Phone numbers in Mainland China":"手机号"} /> */}
            <AutoComplete
              options={options}
              onChange={(val) => handleSearch(val, setOptions)}
              style={{ width: '100%' }}>
              <Input
                placeholder={t("输入手机号或邮箱")}
              />
            </AutoComplete>
          </Form.Item>
          <Form.Item
            name="code"
            help={renderFieldError("code")}
            wrapperCol={{ offset: 2, span: 20 }}
            rules={[{ required: true, message: t("验证码不能为空!") }]}
          >
            <Input
              placeholder={t("验证码")}
              suffix={
                <span
                  onClick={(e)=>{e.stopPropagation()}}
                  id={captchaOpen?buttonKey:""}
                  style={{padding:0}}
                  className={disabled ? "notAllow" : ""}
                >
                  {t(tipName)}
                </span>
              }
            />
          </Form.Item>
        </Form>
        <SliderModal
          setSlider={setSlider}
          sliderVisible={sliderVisible}
        ></SliderModal>
        {showLegacyLoginOptions && <div className={"pwdlogin bjweb-flex-space"}>
          <span
            className="validateText cursor"
            onClick={switchToVerificationLogin}
          >
            {t("验证码登录/注册")}
          </span>
        </div>}
        <div className="text-wrapper_4" onClick={forgetLogin}>
          <span>{t("确认")}</span>
        </div>
        {showH5LoginOptions && (
          <H5LoginOptions
            loginTextKey="验证码登录"
            loginIconType="icon-yanzhengmadenglu"
            onLoginSwitch={switchToVerificationLogin}
            onWechatLogin={onWechatLogin}
          />
        )}
      </div>
      {captchaOpen && <Captcha button={`#${buttonKey}`} phone={phone}  mode={'popup'} callBack={(res)=>{
        if(res){
          sendSmsCode(res)
        }
      }} />}
    </div>
  );
}
